import { createClient } from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_ANON_KEY, hasSupabaseConfig } from './config'

export const supabase = hasSupabaseConfig
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null

/** Kaster videre med en lesbar melding i stedet for Supabase sitt rå objekt. */
export function unwrap({ data, error }) {
  if (error) throw new Error(error.message || 'Noe gikk galt')
  return data
}
